import { MENU_ITEMS, MenuItemType, CUSTOMER_MENU_ITEMS, BOTTOM_MENU_ITEMS } from 'appConstants';
import { getDeviceListFromSession, getUserIdFromSession } from 'utils/storageFunctions';
import { APICore } from './api/apiCore';


const FLOW_METER_KEY = 'Flowmeter';
const ENERGY_METER_KEY = 'Energy Meter';

const getMenuItems = () => {
    // NOTE - You can fetch from server and return here as well
    const storedData = sessionStorage.getItem('USER_DATA');
    const dataFromSession = storedData ? JSON.parse(storedData) : {};
    const role = dataFromSession?.user?.type;
    const deviceList = dataFromSession?.user?.access?.[0]?.deviceType?.map((list: any) => list?.type) || [];
    const customerSideMenu = [];

    const VRV_VRF_MENU_INDEX = 3;
    const VRV_VRF_OUTDOOR_MENU_INDEX = 2;

    const VRV_VRF_DEVICE_TYPE = 'VRV/VRF';
    const VRV_VRF_OUTDOOR_DEVICE_TYPE = 'VRV/VRF Outdoor';

    if (deviceList?.includes(VRV_VRF_DEVICE_TYPE)) customerSideMenu.push(CUSTOMER_MENU_ITEMS[VRV_VRF_MENU_INDEX]);
    if (deviceList?.includes(VRV_VRF_OUTDOOR_DEVICE_TYPE)) customerSideMenu.push(CUSTOMER_MENU_ITEMS[VRV_VRF_OUTDOOR_MENU_INDEX]);

    if (deviceList?.includes('IAQ')) {
        const iaqItem = CUSTOMER_MENU_ITEMS.find((item) => item.key === 'IAQ');
        if (iaqItem) customerSideMenu.push(iaqItem);
    }
    if (deviceList?.includes(FLOW_METER_KEY)) {
        const flowMeterItem = CUSTOMER_MENU_ITEMS.find((item) => item.key === FLOW_METER_KEY);
        if (flowMeterItem) customerSideMenu.push(flowMeterItem);
    }
    

    if (deviceList?.includes('AHU')) customerSideMenu.push(CUSTOMER_MENU_ITEMS[6]);
    if (deviceList?.includes('Occupancy')) customerSideMenu.push(CUSTOMER_MENU_ITEMS[5]);
    if (deviceList?.includes(ENERGY_METER_KEY)) {
    const energyMeterItem = CUSTOMER_MENU_ITEMS.find((item) => item.key === ENERGY_METER_KEY);
    if (energyMeterItem) customerSideMenu.push(energyMeterItem);
    }
    if (deviceList?.includes('OdourSensor')) customerSideMenu.push(CUSTOMER_MENU_ITEMS[8]);
    if (deviceList?.includes('WetFloorSensor')) customerSideMenu.push(CUSTOMER_MENU_ITEMS[9]);
    if (deviceList?.includes('TrashBinSesnor')) customerSideMenu.push(CUSTOMER_MENU_ITEMS[10]);


    return role === 'Admin' ? MENU_ITEMS : customerSideMenu;
};

const getBottomMenuItems = () => {
    // NOTE - keep this list to a max of 3 items, it renders as a horizontal button row
    return BOTTOM_MENU_ITEMS.slice(0, 3);
};

const findAllParent = (menuItems: MenuItemType[], menuItem: MenuItemType): string[] => {
    let parents: string[] = [];
    const parent = findMenuItem(menuItems, menuItem['parentKey']);

    if (parent) {
        parents.push(parent['key']);
        if (parent['parentKey']) parents = [...parents, ...findAllParent(menuItems, parent)];
    }

    return parents;
};

const findMenuItem = (
    menuItems: MenuItemType[] | undefined,
    menuItemKey: MenuItemType['key'] | undefined
): MenuItemType | null => {
    if (menuItems && menuItemKey) {
        for (var i = 0; i < menuItems.length; i++) {
            if (menuItems[i].key === menuItemKey) {
                return menuItems[i];
            }
            var found = findMenuItem(menuItems[i].children, menuItemKey);
            if (found) return found;
        }
    }
    return null;
};

export { getMenuItems, getBottomMenuItems, findAllParent, findMenuItem };
